export const clearCrendentialsOnStorage = () => {
  window?.sessionStorage?.clear();
};
